// Auth route — `/auth/password-reset/confirm` (Wave D4).
//
// Landing page for password-reset confirm links. The existing `/auth/reset`
// route handles the same flow (token → new password), but PROJECT-STATE.md
// flagged that some email templates point at `/auth/password-reset/confirm`.
// We keep the URL stable by mounting the same `<ResetPasswordPage>` here
// with the same search-param contract.

import { createRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '@/features/auth/ResetPasswordPage';

import { Route as RootRoute } from '../../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/password-reset/confirm',
  validateSearch: (search): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: ResetPasswordPage,
});
